import {
    PrismaRequestStatus,
    prismaRequestStatusDecoder
} from './PrismaRequestStatus'
import {LocalDateTime} from 'js-joda'
import { boolean, Decoder, field, nullable, number, object, string } from 'json-bouncer'
import {localDateTimeDecoder} from '../Data/DecodeHelper'

export interface M {
    readonly id: number
    readonly bpsUserId: number
    readonly status: PrismaRequestStatus
    readonly statusText: string
    readonly name: string
    readonly description: string
    readonly desiredDeliveryDate: LocalDateTime | null
    readonly desiredDeliveryAddress: string | null
    readonly isStandardProductRequest: boolean
    readonly printProductId: number | null
    readonly lithoProductId: number | null
    readonly netPrintPrice: number | null
    readonly netLithoPrice: number | null
    readonly amount: number
    readonly printManufacturerId: number | null
    readonly lithoManufacturerId: number | null
    readonly printOfferDeadline: LocalDateTime | null
    readonly lithoOfferDeadline: LocalDateTime | null
    readonly created: LocalDateTime
    readonly updated: LocalDateTime
}

export function decoder(): Decoder<M> {
    return object({
        id: field('id', number()),
        bpsUserId: field('bpsUserId', number()),
        status: field('status', prismaRequestStatusDecoder()),
        statusText: field('statusText', string()),
        name: field('name', string()),
        description: field('description', string()),
        desiredDeliveryDate:
            field('desiredDeliveryDate', nullable(localDateTimeDecoder())),
        desiredDeliveryAddress: field('desiredDeliveryAddress', nullable(string())),
        printProductId: field('printProductId', nullable(number())),
        lithoProductId: field('lithoProductId', nullable(number())),
        netPrintPrice: field('netPrintPrice', nullable(number())),
        netLithoPrice: field('netLithoPrice', nullable(number())),
        amount: field('amount', number()),
        printManufacturerId: field('printManufacturerId', nullable(number())),
        lithoManufacturerId: field('lithoManufacturerId', nullable(number())),
        isStandardProductRequest: field('isStandardProductRequest', boolean()),
        printOfferDeadline:
            field('printOfferDeadline', nullable(localDateTimeDecoder())),
        lithoOfferDeadline:
            field('lithoOfferDeadline', nullable(localDateTimeDecoder())),
        created: field('created', localDateTimeDecoder()),
        updated: field('updated', localDateTimeDecoder()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/PrismaRequest.ts